module.exports = __webpack_public_path__ + "img/1970East-077_WEB-min.2dfcf810.jpg";